/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as HERBUI from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import assignLocation from "../components/Pdf/AssignLocation.pdf";
import mobileNumberUpdation from "../components/Pdf/MobileNumberUpdationThroughDDOLogin.pdf";

export default function MobileApp() {
    return (
        <>   <Header />
            <div className="main_section"> </div>
            <HERBUI.Container style={{ marginTop: "80px" }}>
                <HERBUI.Row>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing">
                        <div className="inner-herbpage-service-title1">
                            <h1>APFRS Mobile App</h1>
                        </div>
                    </HERBUI.Col>
                </HERBUI.Row>
            </HERBUI.Container>
            <HERBUI.Container className=" bg-white">
                <HERBUI.Row className="pt-4">
                    <div>
                        <ul class="list-group list-group-flush border">
                            <li class="list-group-item"><a href={assignLocation} target="_blank" rel="noreferrer">User Manual for DDO's to Assign Locations</a></li>
                            <li class="list-group-item"><a href={mobileNumberUpdation} target="_blank" rel="noreferrer">User Manual for DDO's to Employee Mobile Number Updation</a></li>
                        </ul>
                    </div>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mt-4" />
                </HERBUI.Row >
            </HERBUI.Container>
            <Footer />
        </>
    )
}